@if (showHelp) {
    <ms-onboarding-tooltip [showHelp]="showHelp" [message]="sitecoreEventDetails.eventDetails.EventSwitcherOnboarding" />
}
